module.exports = __webpack_public_path__ + "img/sm.932eef5e.svg";